import { DROPDOWN_SIZE, Dropdown, DropdownButton, DropdownMenu, DropdownMenuItem } from '@repo/design-system/index'
import { useState } from 'react'
import { GTM_CLICK_EVENT, sendGTMEvent, useEventTracking } from '../../../helpers/gtmHelper'
import { PRICING_CURRENCY_OPTIONS } from '../../../modules/consts/pricing'
import { STUDENT_BTN_ID } from '../../../modules/ids/gtm/student'
import { useProductContext } from './Pricing/ProductContext'

export const AITutorPricingSwitchCurrency = ({ currency, setCurrency }) => {
  const DEFAULT_OPTION = PRICING_CURRENCY_OPTIONS[3] // fallback when no corresponding country code
  const [selected, setSelected] = useState({
    label: PRICING_CURRENCY_OPTIONS.find((item) => item.currency == currency)?.name ?? DEFAULT_OPTION.name,
    value: PRICING_CURRENCY_OPTIONS.find((item) => item.currency == currency)?.currency ?? DEFAULT_OPTION.currency,
  })

  return (
    <div>
      <Dropdown selected={selected} setSelected={setSelected} size={DROPDOWN_SIZE.SM}>
        <DropdownButton wrapperClassName="min-w-[43px]">
          <div
            onClick={() =>
              sendGTMEvent(STUDENT_BTN_ID.CLICK_PURCHASE_CURRENCY, {
                device_type: 'pc',
              })
            }
            className="Body2-14Md"
          >
            {selected.label}
          </div>
        </DropdownButton>
        <DropdownMenu wrapperClassName="z-[40]">
          {PRICING_CURRENCY_OPTIONS.map((item, i) => {
            return (
              <DropdownMenuItem
                key={i}
                value={item.currency}
                className="Body2-14Md whitespace-nowrap"
                onClick={() => setCurrency(item.currency)}
              >
                {item.name}
              </DropdownMenuItem>
            )
          })}
        </DropdownMenu>
      </Dropdown>
    </div>
  )
}

const PricingSwitchCurrency = () => {
  const { purchaseInfo, setPurchaseInfo } = useProductContext()
  const { countryCode } = purchaseInfo || {}
  const { sendClickEvent } = useEventTracking()

  const DEFAULT_OPTION = PRICING_CURRENCY_OPTIONS[2] // fallback when no corresponding country code
  const [selected, setSelected] = useState({
    label: PRICING_CURRENCY_OPTIONS.find((item) => item.country_code == countryCode)?.name ?? DEFAULT_OPTION.name,
    value:
      PRICING_CURRENCY_OPTIONS.find((item) => item.country_code == countryCode)?.country_code ??
      DEFAULT_OPTION.country_code,
  })

  return (
    <div>
      <Dropdown selected={selected} setSelected={setSelected} size={DROPDOWN_SIZE.SM}>
        <DropdownButton wrapperClassName="min-w-[43px]">
          <div
            onClick={() => sendClickEvent({ button_name: GTM_CLICK_EVENT.PURCHASE_CURRENCY })}
            className="Body2-14Md"
          >
            {selected.label}
          </div>
        </DropdownButton>
        <DropdownMenu wrapperClassName="z-[40]">
          {PRICING_CURRENCY_OPTIONS.map((item, i) => {
            return (
              <DropdownMenuItem
                key={i}
                value={item.country_code}
                className="Body2-14Md whitespace-nowrap"
                onClick={() => {
                  setPurchaseInfo((prev) => ({ ...prev, countryCode: item.country_code }))
                }}
              >
                {item.name}
              </DropdownMenuItem>
            )
          })}
        </DropdownMenu>
      </Dropdown>
    </div>
  )
}

export default PricingSwitchCurrency
